import React, {useState, useEffect} from 'react';
import {Table} from 'semantic-ui-react';
import styled from 'styled-components';
import StatusBadge from './StatusBadge';
import FileActionButtons from './FileActionButtons';
import FileNameLink from './FileNameLink';
import EmptyState from './EmptyState';
import FileOrdered from './FileOrdered';
import {getRoles} from '../../../services/userRights';

const StyledTableWrapper = styled.div`
    padding: 0 27px;
`;

const MassUploadTable = ({files, onEdit, onView, onDelete, onDownload, onCancel, formatDate}) => {
    const [isCoordinator, setIsCoordinator] = useState(false);

    useEffect(() => {
        const roles = getRoles() || [];
        setIsCoordinator(roles.includes('Coordinator'));
    }, []);

    const formatClientCompanies = (file) => {
        const names = file.clientCompanyNames || [];
        return names.length > 0 ? names.join(', ') : '-';
    };

    const getFileLink = (file) => {
        if (file.fileType === 'Calculation') {
            return `/massupload/calculation/${file.id}`;
        } else {
            return `/massupload/edit/${file.id}`;
        }
    };

    if (files.length === 0) {
        return (
            <StyledTableWrapper>
                <EmptyState
                    message="Файлы не найдены."
                    suggestion="Попробуйте изменить параметры поиска или загрузите новый файл."
                />
            </StyledTableWrapper>
        );
    }

    return (
        <StyledTableWrapper>
            <Table className="ui table">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>№ МЗ</Table.HeaderCell>
                        <Table.HeaderCell>Дата загрузки файла</Table.HeaderCell>
                        <Table.HeaderCell>Название файла</Table.HeaderCell>
                        <Table.HeaderCell>Автор</Table.HeaderCell>
                        {isCoordinator && <Table.HeaderCell>Юр. лицо</Table.HeaderCell>}
                        <Table.HeaderCell>Ошибки</Table.HeaderCell>
                        <Table.HeaderCell>Статус</Table.HeaderCell>
                        <Table.HeaderCell>Заказано</Table.HeaderCell>
                        <Table.HeaderCell>Дата и время операции</Table.HeaderCell>
                        <Table.HeaderCell>Действия</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {files.map(file => (
                        <Table.Row key={file.id}>
                            <Table.Cell>{file.id}</Table.Cell>
                            <Table.Cell>{formatDate(file.uploadDate)}</Table.Cell>
                            <Table.Cell>
                                <FileNameLink
                                    fileName={file.originalFileName}
                                    status={file.status}
                                    onClick={() => onEdit(file)}
                                    fileLink={getFileLink(file)}
                                />
                            </Table.Cell>
                            <Table.Cell>{file.authorName || '-'}</Table.Cell>
                            {isCoordinator && (
                                <Table.Cell>{formatClientCompanies(file)}</Table.Cell>
                            )}
                            <Table.Cell className="text-danger">{file.errorRows}</Table.Cell>
                            <Table.Cell>
                                <StatusBadge status={file.status} parseErrors={file.parseErrors} />
                            </Table.Cell>
                            <Table.Cell>
                                <FileOrdered file={file} />
                            </Table.Cell>
                            <Table.Cell>
                                {file.lastOperationDate && formatDate(file.lastOperationDate)}
                            </Table.Cell>
                            <Table.Cell>
                                <FileActionButtons
                                    file={file}
                                    onEdit={onEdit}
                                    onView={onView}
                                    onDelete={onDelete}
                                    onDownload={onDownload}
                                    onCancel={onCancel}
                                />
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </StyledTableWrapper>
    );
};

export default MassUploadTable;




// WEBPACK FOOTER //
// ./App/pages/massUpload/components/MassUploadTable.jsx